import { module } from 'angular';
import iconComponent from './icon.component';
import iconSourceDirective from './icon-src.directive';

export default module('app')
	.component('icon', iconComponent)
	.directive('iconSrc', iconSourceDirective)
	.name;
